import { moveToFulfilled, moveToPendingIfNotFulfilled, moveToRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { AllCampaignsLoadAction } from '../../domains/allCampaigns/loadActions.types';
import { CampaignsListLoadMoreFulfilledAction } from '../../domains/allCampaigns/loadMoreAllCampaignsActions.types';
import { CampaignEditFulfilledAction, CampaignPublishFulfilledAction } from '../../domains/campaignEdit/actions.types';
import { CampaignLoadAction } from '../../domains/campaigns/actions.types';
import { MyLeaderSponsoredCampaignsLoadFulfilledAction } from '../../domains/myLeaderSponsoredCampaigns/loadActions.types';
import { TrendingCampaignsLoadFulfilledAction } from '../../domains/trendingCampaigns/loadActions.types';

import { Campaigns } from './types';

export type CampaignsAction =
  | AllCampaignsLoadAction
  | CampaignLoadAction
  | CampaignEditFulfilledAction
  | CampaignPublishFulfilledAction
  | CampaignsListLoadMoreFulfilledAction
  | MyLeaderSponsoredCampaignsLoadFulfilledAction
  | TrendingCampaignsLoadFulfilledAction;

const initialState: Campaigns = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<Campaigns, CampaignsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'ALL_CAMPAIGNS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.campaigns);
    case 'ALL_CAMPAIGNS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.campaigns);
    case 'CAMPAIGN.LOAD_PENDING':
      return moveToPendingIfNotFulfilled(state, action.payload.id);
    case 'CAMPAIGN.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.campaigns);
    case 'CAMPAIGN.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.id], action.payload.error);
    case 'CAMPAIGN.EDIT_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.campaigns);
    case 'CAMPAIGN.PUBLISH_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.campaigns);
    case 'MY_LEADER_SPONSORED_CAMPAIGNS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.campaigns);
    case 'TRENDING_CAMPAIGNS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.campaigns);
    default:
      return state;
  }
};

export default reducer;
